import { Component, OnInit, signal } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { MessageService, ConfirmationService, SelectItem } from "primeng/api";
import { Observable, of } from "rxjs";
import {
  LEVEL_PUBLISHED,
  PARAM_PAGES_PATH,
  STATE_LIST,
  STATE_PAGES_PUBLISHED,
  STATE_PUBLISHED,
  TEMPLATE_PUBLISHED,
} from "src/app/admin/constants/constants";
import { AbstractFormComponent } from "src/app/common/abstract-edit.component";
import { Pages } from "src/app/models/pages";
import { Users } from "src/app/models/users";
import { PagesService } from "src/app/services/pages.service";
import { UsersService } from "src/app/services/users.service";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { SharedModule } from "primeng/api";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { ReactiveFormsModule } from "@angular/forms";
import { Ripple } from "primeng/ripple";
import { RouterLink } from "@angular/router";
import { SelectButtonModule } from "primeng/selectbutton";
import { TabsModule } from "primeng/tabs";
import { ToastModule } from "primeng/toast";
import { TopNavComponent } from "../../../top-nav/top-nav.component";

@Component({
    selector: "app-users-form",
    templateUrl: "./users-form.component.html",
    imports: [ButtonModule, CardModule, ConfirmDialogModule, SharedModule, FormsModule, InputTextModule, ReactiveFormsModule, Ripple, RouterLink, SelectButtonModule, TabsModule, ToastModule, TopNavComponent]
})
export class UsersFormComponent
  extends AbstractFormComponent<Users>
  implements OnInit
{
  pageTitle = signal("");
  form: FormGroup;
  idField = "id";
  formFields = [
    "id",
    "username",
    "password",
    "email",
    "display_name",
    "is_active",
  ];

  item$: Observable<Users> = of(); // Initialize with an empty Observable
  stateOptions = STATE_LIST;
  service = this.usersService; // Implement the abstract service property
  element = signal<Users | null>(null);
  selectedStatePublished: SelectItem[] = [];
  selectedTemplatePublished: SelectItem[] = [];
  selectedLevelPublished: SelectItem[] = [];
  statePublished = STATE_PAGES_PUBLISHED;
  levelPublished: any[];
  selectedPagesPublished: Pages[];
  pages: Pages[] = [];
  templatePublished: any[];

  constructor(
    protected fb: FormBuilder,
    private usersService: UsersService,
    messageService: MessageService,
    confirmationService: ConfirmationService,
    router: Router,
    route: ActivatedRoute
  ) {
    super(
      fb,
      messageService,
      confirmationService,
      router,
      route,
      PARAM_PAGES_PATH
    );

    this.stateOptions = STATE_LIST;
  }

  ngOnInit() {
    this.initializeForm();
    const id = this.route.snapshot.paramMap.get("id");
    if (id) {
      this.pageTitle.set("Modifica News");
      this.loadItem(+id);
    } else {
      this.pageTitle.set("Aggiungi News");
    }

    this.templatePublished = TEMPLATE_PUBLISHED;
    this.levelPublished = LEVEL_PUBLISHED;
  }

  initializeForm() {
    this.form = this.fb.group({
      id: [""],
      username: ["", Validators.required],
      email: [""],
      display_name: [""],
      password: [""],
      is_active: ["0"],
    });
  }

  loadItem(id: number) {
    this.service.getId(id).subscribe(
      (res) => {
        this.element.set(res);
        this.form.patchValue({
          username: res.username,
          display_name: res.display_name,
          password: "",
          email: res.email,
          is_active: res.is_active,
          id: res.id,
        });
      },
      (error) => (this.error.set(error))
    );
  }
}
